import { gql } from '@apollo/client';

export default gql`
  mutation CreateTagMutation($tag: TagInput!) {
    createTag(input: { tag: $tag }) {
      tag {
        id
      }
    }
  }
`;
